import { render, staticRenderFns } from "./LanguageCurrencyPicker.vue?vue&type=template&id=53e11326&scoped=true"
import script from "./LanguageCurrencyPicker.vue?vue&type=script&lang=js"
export * from "./LanguageCurrencyPicker.vue?vue&type=script&lang=js"
import style0 from "./LanguageCurrencyPicker.vue?vue&type=style&index=0&id=53e11326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e11326",
  null
  
)

export default component.exports